module.exports = __webpack_public_path__ + "static/media/landing-orgAspect.0958615e.webm";